<template>
  <div class="wrap-form" v-on:keyup.enter="onSubmit">
    <el-form class="my-form" ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="" prop="title">
        <el-input ref="input" resize="none" v-model="form.task_group_name" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box">
      <wf-button @click="onSubmit" :disabled="!form.task_group_name">保存</wf-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: "",
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskListId: {
      type: [Number, String],
      default: 0
    },
    visibleAddChecklist: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        task_type_id: '', //所属项目
        task_group_name: this.name, //清单标题
        // orderby: 0
      },
      rules: {
        task_group_name: [
          { required: true, trigger: "change", message: "任务分组不能为空" },
          { max: 140, trigger: "change", message: "任务分组不能超过140个字符" }
        ]
      }
    };
  },
  computed: {
    // eslint-disable-next-line vue/no-dupe-keys
    isEdit() {
      return this.editData.pid ? true : false;
    }
  },
  methods: {
    ...mapActions('task/task', ['addChecklist', 'editChecklist']),
    resetForm() {
      this.form.task_group_name = "";
      // this.form.orderby = 0;
      this.$refs.form.resetFields();
    },
    onSubmit() {
      // 表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            const param = {
              id: this.projectId,
              task_group_name: this.form.task_group_name,
              task_type_id: this.$store.state['taskType/taskType'].isSelectProject.id
            }
            this.editChecklist(param).then(res => {
              this.$emit("success", this.form.task_group_name);
              this.resetForm();
            });
          } else {
            this.form.task_type_id = this.$store.state['taskType/taskType'].isSelectProject.id
            this.addChecklist(this.form).then(res => {
              this.$emit("success",'',res);
              this.resetForm();
            });
          }
        }
      });
    }
  },
  watch: {
    visibleAddChecklist: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.input.focus()
          })
        }
      },
      immediate: true
    },
    name: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.task_group_name = newVal;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-form {
  .submit-box {
    display: flex;
    justify-content: flex-end;
    .wf-button{
      width: 100%;
    }
  }
  .my-form .el-form-item .el-form-item__content {
    line-height: 40px !important;
  }
}
</style>
